import { MdOutlineModeEditOutline } from 'react-icons/md';
import { Flex, ListItem, UnorderedList } from '@chakra-ui/react';

import { useAppDispatch } from '../redux/store';
import { useTranslation } from 'react-i18next';
import { setCategoryToUpdate } from '../redux/slices/categoryToUpdateSlice';

import styles from './styles/suggestion-list.module.scss';

interface SuggestionsListProps {
  id: string;
  hasChanged: boolean;
  allCategories: string[];
  activeSuggestionIndex: number;
  filteredSuggestions: string[];
  // input: string;
  // setInput: (value: React.SetStateAction<string>) => void;
  categoryInputValue: string;
  setShowSuggestions: (value: React.SetStateAction<boolean>) => void;
  setFilteredSuggestions: (value: React.SetStateAction<string[]>) => void;
  // formik props
  setFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean | undefined
  ) => void;
  // open edit category modal
  onOpenModal: () => void;
}

export const SuggestionsList: React.FC<SuggestionsListProps> = ({
  id,
  // setInput,
  hasChanged,
  allCategories,
  categoryInputValue,
  filteredSuggestions,
  onOpenModal,
  setFieldValue,
  setShowSuggestions,
  // setFilteredSuggestions,
}) => {
  // i18n
  const { t } = useTranslation();

  const INSTRUCTION_TEXT = t('category-instruction');

  // to set client state: categoryToUpdate
  const dispatch = useAppDispatch();

  const shownSuggestions =
    categoryInputValue === '' || !hasChanged
      ? [INSTRUCTION_TEXT, ...allCategories]
      : [INSTRUCTION_TEXT, ...filteredSuggestions];

  return shownSuggestions.length > 1 ? (
    // show suggestion list
    <UnorderedList className={styles.suggestionList}>
      {shownSuggestions.map((suggestion, index) => (
        <ListItem
          className={`${styles.suggestionItem} ${
            index === 0 ? styles.instruction : ''
          }`}
          key={index}
        >
          <Flex justifyContent={'space-between'} alignItems={'center'}>
            <div
              className={styles.suggestionSpanDiv}
              onClick={() => {
                if (index === 0) return;
                // setInput(suggestion);
                setShowSuggestions(false);
                // for formik field
                setFieldValue(id!, suggestion);
              }}
            >
              <span>{suggestion}</span>
            </div>

            <div
              className={styles.editIconDiv}
              onClick={() => {
                // set categoryToUpdate
                dispatch(setCategoryToUpdate(suggestion));
                onOpenModal();
              }}
            >
              {index !== 0 && (
                <MdOutlineModeEditOutline className={styles.editIcon} />
              )}
            </div>
          </Flex>
        </ListItem>
      ))}
    </UnorderedList>
  ) : (
    // show `create xxxooo`
    <UnorderedList className={styles.suggestionList}>
      {[INSTRUCTION_TEXT, categoryInputValue].map((suggestion, index) => (
        <ListItem
          className={`${styles.suggestionItem} ${
            index === 0 ? styles.instruction : ''
          }`}
          key={index}
          onClick={() => {
            if (index === 0) return;
            // setInput(suggestion);
            setShowSuggestions(false);
            // for formik field
            setFieldValue(id!, suggestion);
          }}
        >
          {index === 0 ? (
            <div className={styles.createCategoryWrapper}>{suggestion}</div>
          ) : (
            <div className={styles.createCategoryWrapper}>
              <span
                style={{
                  color: '#888',
                  fontSize: '16px',
                  marginRight: '6px',
                }}
              >
                {t('create')}
              </span>
              <span
                style={{ fontWeight: '500' }}
                onClick={() => {
                  // setInput(input);
                  setShowSuggestions(false);
                }}
              >
                {suggestion}
              </span>
            </div>
          )}
        </ListItem>
      ))}
    </UnorderedList>
  );
};
